import {Link} from "react-router-dom";
import ContactStillNeedHelpComponent from "../../components/contact/ContactStillNeedHelpComponent.tsx";
import ContactPageLayout from "./ContactPageLayout.tsx";

export default function ContactReturnPage() {
    return (
        <ContactPageLayout
            meta_title={"Returnering af udstyr"}
            meta_description={"Som Hiper-kunde skal du selv betale for at sende dit udstyr til os, når du opsiger dit abonnement. Læs om hvordan du returnerer dit udstyr her."}
            title={"Returnering af udstyr"}
            className={"page-contact-return"}
            content={
                <>
                    <section className="contact-content">
                        <p>Som Hiper-kunde skal du selv betale for at sende dit udstyr til os, når du opsiger dit abonnement.</p>
                        <p>Du kan læse her, hvordan du gør:</p>
                        <Link
                            to={'/hjaelp/mit-abonnement/returner-udstyr'}
                            className={'button button--montserrat teal'}
                        >Hvordan returnerer jeg mit udstyr?</Link>
                    </section>

                    <ContactStillNeedHelpComponent phone={true} form={true}/>
                </>
            }
        />
    )
}
